(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    (function(){
        // material card expand link to open card by removing css class
        // add a link event using "material-card__expand" class of the link
        document.addEventListener('click', function (event) {
            var link = event.target.closest('.material-card__action-link--expand');
            if (!link) return;
            event.preventDefault();
            var card = link.closest('.material-card');
            card.classList.add('expanded');
        });

        // write a similar function to the above but to collase the card
        document.addEventListener('click', function (event) {
            var link = event.target.closest('.material-card__action-link--collapse');
            if (!link) return;
            event.preventDefault();
            var card = link.closest('.material-card');
            card.classList.remove('expanded');
        });

    })();

    (function(){
        // https://stackoverflow.com/questions/27078285/simple-throttle-in-javascript
        // Returns a function, that, when invoked, will only be triggered at most once
        // during a given window of time. Normally, the throttled function will run
        // as much as it can, without ever going more than once per `wait` duration;
        // but if you'd like to disable the execution on the leading edge, pass
        // `{leading: false}`. To disable execution on the trailing edge, ditto.
        function throttle(func, wait, options) {
            var context, args, result;
            var timeout = null;
            var previous = 0;
            if (!options) options = {};
            var later = function() {
                previous = options.leading === false ? 0 : Date.now();
                timeout = null;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            };
            return function() {
                var now = Date.now();
                if (!previous && options.leading === false) previous = now;
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0 || remaining > wait) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    previous = now;
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                } else if (!timeout && options.trailing !== false) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        }    // js-equal-height-plane
        // js-equal-height-group

        function setEqualHeight() {
            var groups = {};
            var bodyRect = document.body.getBoundingClientRect();
            document.querySelectorAll('.js-equal-height').forEach(function (containerElem) {
                containerElem.querySelectorAll('.js-equal-height-item').forEach(function (itemElem) {
                    var rect = itemElem.getBoundingClientRect();
                    var y = rect.top - bodyRect.top;
                    groups[y] = groups[y] || [];
                    groups[y].push(itemElem);
                });
            });

            
            Object.values(groups).forEach(function (group, i) {
                var height = 0;
                group.forEach(function (itemElem) {
                    itemElem.classList.remove('expanded');
                    itemElem.querySelector('.material-card__face').style.minHeight = 'auto';
                    //itemElem.style.minHeight = 'auto';
                    height = Math.max(height, itemElem.offsetHeight);
                });
                group.forEach(function (itemElem) {
                    itemElem.querySelector('.material-card__face').style.minHeight = height + 'px';
                    //itemElem.style.minHeight = height + 'px';
                });
            });
        }
        window.addEventListener('resize', throttle(setEqualHeight, 100));
        window.addEventListener('load', setEqualHeight);
        setTimeout(setEqualHeight, 500);
    })();

}));
